// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"7e3c8d39","301":"cd4ceb03","838":"3ffb8ce4"}[chunkId] + ".chunk.js";
};